var _a;
import { __assign, __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { FromDomin, UserType, UType, } from '../../model/entity/account-list/account-list.interface';
import { dataFieldNamingHandler, exceptionHandler } from '../../../base/decorators';
import { INetworkRequestService } from '../../../base/request/network-request.interface';
import { COMMON_COOKIES_KEYS, getCookie, getCookieByCommonKey } from '@tencent/ark-utils/lib/cookie';
import { getBPersonAccountIdMap } from '@tencent/ark-utils/lib/storage/account-id-map';
import { addURLParameters } from '@tencent/ark-utils/lib/url';
import { DISK_LOGOUT } from '../account/cgi-path';
import { ENTERPRISE_ACCOUNT_LIST, GET_USER_MARK_NAME, } from './cgi-path';
var typeMap = (_a = {},
    _a[UserType.WECHAT] = UType.WECHAT,
    _a[UserType.WEWORK] = UType.WEWORK,
    _a);
var isOpenidAccount = function () { return !!getCookie('wedoc_sid'); };
var formatEnterpriseAccountListItem = function (item) {
    // 对于openid登录态uid为微盘id(item.uid) 对于非openid登录态 uid为vid(item.uin) 对c端登录态为tinyid(item.uid)
    var wedriveSid = !isOpenidAccount() ? item.sid : undefined;
    var wedocSid = undefined;
    var wedocOpenid = undefined;
    var tdocUid = undefined;
    var uid;
    if (item.type === UserType.WECHAT || isOpenidAccount()) {
        uid = item.uid;
    }
    else {
        uid = item.uin;
    }
    // session_list 列表不混用，当前登录的是什么类型 session_list 的sid就是什么类型
    if (isOpenidAccount()) {
        wedocSid = item.sid;
        wedocOpenid = item.openid;
        tdocUid = uid;
    }
    return (__assign(__assign({}, item), { corpName: item.corp_name, 
        // c端没有uid就是 uin
        uid: uid, uType: typeMap[item.type], nick: item.name, nickName: item.nick_name, wedriveUin: uid, fromDomain: FromDomin.B_DOMAIN, cookie: {
            wedriveSid: wedriveSid,
            wedocSid: wedocSid,
            wedocOpenid: wedocOpenid,
            tdocUid: tdocUid,
            uType: (typeMap[item.type]),
            // 切换sid后请求资源会种上正确的uid和uid_key不需要主动种uid 故传空
            uid: '',
            /**
             ** 兼容一下c端的类型，避免报错
             **/
            uidKey: '',
            userIndex: '',
            SID: '',
            isMultiLogin: true,
        } }));
};
var formatSessionList = function (sessionList) {
    var personAccountIdMap = getBPersonAccountIdMap();
    var resetUid = function (sessionItem) {
        // 用微盘id 取tinyid c端的uid是tinyid
        if (sessionItem.type === UserType.WECHAT && !sessionItem.uid) {
            sessionItem.uid = personAccountIdMap[sessionItem.uin];
        }
        return sessionItem;
    };
    return sessionList.map(resetUid).filter(function (sessionItem) { return sessionItem.uid; });
};
var replaceNumberId = function (responseText) {
    if (responseText === void 0) { responseText = '{}'; }
    var replacedJsonText = responseText
        .replace(/"uin":(\d+)/g, '"uin":"$1"')
        .replace(/"uid":(\d+)/g, '"uid":"$1"');
    return JSON.parse(replacedJsonText);
};
var EnterpriseAccountListRepository = /** @class */ (function () {
    function EnterpriseAccountListRepository(networkRequestService) {
        this.networkRequestService = networkRequestService;
    }
    EnterpriseAccountListRepository.prototype.getEnterpriseAccountList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, result, _a, body, head;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        url = addURLParameters(ENTERPRISE_ACCOUNT_LIST, {
                            xrsf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
                            get_acct: 'true',
                        });
                        return [4 /*yield*/, this.networkRequestService.instance.get(url)];
                    case 1:
                        result = _c.sent();
                        _a = replaceNumberId((_b = result.request) === null || _b === void 0 ? void 0 : _b.responseText), body = _a.body, head = _a.head;
                        return [2 /*return*/, __assign(__assign({}, result), { data: {
                                    data: formatSessionList(body.session).map(formatEnterpriseAccountListItem),
                                    retcode: head.ret,
                                    msg: head.msg,
                                } })];
                }
            });
        });
    };
    EnterpriseAccountListRepository.prototype.getUserMarkNameListByUids = function (uids) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = addURLParameters(GET_USER_MARK_NAME, {
                            xrsf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
                            uids: "[".concat(uids.join(','), "]"),
                        });
                        return [4 /*yield*/, this.networkRequestService.instance.get(url)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, __assign(__assign({}, result), { data: {
                                    data: result.data.result.rsp,
                                    retcode: result.data.retcode,
                                    msg: result.data.msg,
                                } })];
                }
            });
        });
    };
    EnterpriseAccountListRepository.prototype.delEnterpriseAccountForList = function (weSid) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = addURLParameters(DISK_LOGOUT, {
                    xrsf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
                    sid: weSid,
                });
                return [2 /*return*/, this.networkRequestService.instance.get(url)];
            });
        });
    };
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], EnterpriseAccountListRepository.prototype, "getEnterpriseAccountList", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], EnterpriseAccountListRepository.prototype, "getUserMarkNameListByUids", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], EnterpriseAccountListRepository.prototype, "delEnterpriseAccountForList", null);
    EnterpriseAccountListRepository = __decorate([
        __param(0, INetworkRequestService),
        __metadata("design:paramtypes", [Object])
    ], EnterpriseAccountListRepository);
    return EnterpriseAccountListRepository;
}());
export default EnterpriseAccountListRepository;
